import { Route, Switch } from 'react-router-dom';
import { useGoogleCustomerCheck, useGoogleRestrictedWordCheck } from '@wix/domains-search-suite';
import { AnonymousBusinessEmailResultsPage } from './ResultsPage';
import React, { useMemo } from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
export let GatePath = /*#__PURE__*/function (GatePath) {
  GatePath["ANONYMOUS_BUSINESS_EMAIL_GATE"] = "/";
  return GatePath;
}({});
export const AnonymousBusinessEmailGatePages = _ref => {
  let handlers = _ref.handlers,
    externalViewer = _ref.externalViewer,
    isGoogleCustomerCheckEnabled = _ref.isGoogleCustomerCheckEnabled,
    deviceType = _ref.deviceType;
  const _useGoogleCustomerChe = useGoogleCustomerCheck(),
    checkGoogleCustomerExists = _useGoogleCustomerChe.checkGoogleCustomerExists;
  const _useGoogleRestrictedW = useGoogleRestrictedWordCheck(),
    checkGoogleRestrictedWord = _useGoogleRestrictedW.checkGoogleRestrictedWord;
  const wrappedHandlers = useMemo(() => {
    if (!isGoogleCustomerCheckEnabled || !handlers) {
      return handlers;
    }
    const wrapHandler = originalHandler => {
      return async props => {
        const domainName = props == null ? void 0 : props.domainName;
        if (domainName) {
          if (checkGoogleRestrictedWord({
            domainName
          })) {
            return;
          }
          if (await checkGoogleCustomerExists({
            domainName
          })) {
            return;
          }
        }
        return originalHandler(props);
      };
    };
    return {
      ...handlers,
      ...(handlers.purchase && {
        purchase: wrapHandler(handlers.purchase)
      }),
      ...(handlers.purchaseRootDomainIsRequired && {
        purchaseRootDomainIsRequired: wrapHandler(handlers.purchaseRootDomainIsRequired)
      })
    };
  }, [isGoogleCustomerCheckEnabled, handlers, checkGoogleCustomerExists, checkGoogleRestrictedWord]);
  return /*#__PURE__*/React.createElement(DomainSearchGateModule.SDK.Components.ModalsProvider, null, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: GatePath.ANONYMOUS_BUSINESS_EMAIL_GATE,
    render: () => /*#__PURE__*/React.createElement(AnonymousBusinessEmailResultsPage, {
      handlers: wrappedHandlers,
      externalViewer: externalViewer,
      deviceType: deviceType
    })
  })));
};
//# sourceMappingURL=AnonymousBusinessEmailGatePages.js.map